import { cn } from "@theprelude/core";
import { ReactNode } from "react";

export const Callout = ({
  children,
  type = "notice",
  icon,
  className,
}: {
  children: ReactNode;
  type?: "error" | "notice";
  icon?: ReactNode;
  className?: string;
}) => (
  <div
    className={cn(
      "flex w-fit flex-row items-center p-2",
      type === "error" ? "bg-status-red/10" : "bg-notice/10",
      className,
    )}
  >
    {icon && <div className="mr-1 text-secondary-foreground">{icon}</div>}
    {children}
  </div>
);
